module.exports = __webpack_public_path__ + "img/programme5.923d0429.png";